// src/utils/apiLogger.js

function saveLog(entry, key = "apiErrorLogs", limit = 50) {
  const logs = JSON.parse(localStorage.getItem(key) || "[]");
  logs.unshift(entry);
  if (logs.length > limit) logs.pop();
  localStorage.setItem(key, JSON.stringify(logs));
}

export function logApiError(error, { userId, correlationId } = {}) {
  const logEntry = {
    time: new Date().toISOString(),
    type: "ERROR",
    userId,
    correlationId,
    message: error.message,
    stack: error.stack,
    status: error.response?.status,
  };

  saveLog(logEntry);

  if (process.env.NODE_ENV === "development") {
    console.error(
      `API Error for user=${userId} correlationId=${correlationId}`,
      logEntry
    );
  }
}
